import React from 'react';
import CoursesPage from './CoursesComponents/CoursesPage';

const CoursesView = (props) => {
  return <CoursesPage {...props} />;
};

export default CoursesView;
